/**
 * Ajax文件下载器
 * 
 * Author:XuDL
 * 
 * Version:1.0.0
 */
(function() {
	require('../../static/js/jquery-2.0.0.min.js');

	// 正则校验
	var r20 = /%20/g, rhash = /#.*$/, rquery = (/\?/), rnoContent = /^(?:GET|HEAD)$/;

	var AjaxFileDownloader = function(options) {
		this.action(options);
		return this;
	};

	// 原型方法
	AjaxFileDownloader.prototype = {
		constructor : AjaxFileDownloader, // 构造器
		action : function(options) {
			try {
				var $this = this;
				var opts = $.extend({}, options);
				// 校验
				if (!opts.url) {
					console.log("AjaxFileDownloader url is requried");
					return;
				}
				if (!opts.type) {
					console.log("AjaxFileDownloader type is requried");
					return;
				}
				// 请求类型
				opts.type = opts.type.toUpperCase();

				// Determine if request has content
				opts.hasContent = !rnoContent.test(opts.type);

				// 创建xhr对象
				var xhr = new XMLHttpRequest();

				// 如果为json格式就转换一下
				if(opts.data && typeof opts.data !== "string"
						&& (opts.contentType || "")
								.indexOf("application/json") === 0){
					opts.data = JSON.stringify(opts.data);
				}
				// Convert data if not already a string
				if (opts.data && typeof opts.data !== "string") {
					opts.data = $.param(opts.data);
				}

				if (!opts.hasContent) {
					var tmpUrl = opts.url.replace(rhash, "");
					// get和head需要在url上加参数
					if (opts.data && typeof opts.data === "string") {
						tmpUrl += (rquery.test(tmpUrl) ? "&" : "?") + opts.data;
						// 因为参数加到url上了，后面就不用了send了
						delete opts.data;
					}
					opts.url = tmpUrl;
				} else if (opts.data
						&& (opts.contentType || "")
								.indexOf("application/x-www-form-urlencoded") === 0) {
					// post需要在send加
					// data转成&符连接的参数格式
					// ajax - Change '%20' to '+' if this is encoded form body content
					opts.data = opts.data.replace(r20, "+");
				}

				// open要先于setRequestHeader前执行
				xhr.open(opts.type, opts.url, opts.async);

				// 数据类型
				if (opts.data && opts.contentType !== false || opts.contentType) {
					xhr.setRequestHeader("Content-Type", opts.contentType);
				}

				// 请求头
				if (opts.headers) {
					$.each(opts.headers, function(i, n) {
						xhr.setRequestHeader(i, opts.headers[i]);
					});
				}

				// xhr.responseType = 'blob';

				xhr.onload = function() {
					if (opts.complete) {
						opts.complete.apply($this, [ xhr.status, xhr.response, options ]);
					}
				}
				// 设置返回值格式为blob，否则可能文件会出错
				xhr.responseType = 'blob';
				xhr.onreadystatechange = function() {
					// readyState 0: 请求未初始化 1: 服务器连接已建立 2: 请求已接收 3: 请求处理中 4:
					// 请求已完成，且响应已就绪
					if (xhr.readyState === 4 && xhr.status === 200) {
						var allHeaders = xhr.getAllResponseHeaders();
						try {
							if(allHeaders.indexOf("ajax-result") >= 0){
								// 如果包含ajax-result返回结果则先要判断结果
								var ajaxResult = xhr.getResponseHeader("ajax-result");
								if(ajaxResult){
									ajaxResult = decodeURI(ajaxResult);
									var ajaxResultJson = $.parseJSON(ajaxResult);
									if("000" != ajaxResult.code){
										if(opts.error){
											opts.error.apply($this, [ ajaxResultJson, xhr.status, xhr.response, options ]);
											return;
										}
									}
								}
							}
							
							var name = xhr.getResponseHeader("ajax-filename");
							// utf8需要转码
							if(name){
								name = decodeURI(name);
							}
							var mimeType = xhr
									.getResponseHeader("ajax-mimeType");
							if (name && mimeType) {
								// 如果为空说明不是正常的文件流格式
								if (!xhr.response) {
									throw new Error(
											"Response is not a file stream");
								}
								// 使用response流创建一个Blob对象
								var blob = new Blob([ xhr.response ], {
									type : mimeType
								});
								/* 以下方法不兼容ie和火狐，所以废弃了
								// 创建一个URL对象
								var csvUrl = URL.createObjectURL(blob);
								// 创建一个DOM的a标签
								var link = document.createElement('a');
								// 设置链接
								link.href = csvUrl;
								// 设置下载的文件名
								link.download = name;
								// 模拟点击，出发浏览器下载
								link.click();*/
								// ie必须使用msSaveOrOpenBlob
								if('msSaveOrOpenBlob' in navigator){
									 window.navigator.msSaveOrOpenBlob(blob, name);
								} else {
									// 兼容google和火狐
									var reader = new FileReader();
									reader.readAsDataURL(blob);  // 转换为base64，可以直接放入a表情href
									reader.onload = function (e) {
									// 转换完成，创建一个a标签用于下载
									var a = document.createElement("a");
									a.download = name;
									a.href = e.target.result;
									$("body").append(a);  // 修复firefox中无法触发click
									a.click();
									$(a).remove();
									}
								}
								if (opts.success) {
									opts.success.apply($this, [ xhr.status,
											xhr.response, options ]);
								}
							}else{
								throw new Error("There is no ajax-filename or ajax-mimeType in responseHeaders");
							}
						} catch (e) {
							if (opts.error) {
								opts.error.apply($this, [ e, xhr.status,
										xhr.response, options ]);
							}
							console.error("ajaxFileDownloader error with:", e);
						}
					}
				};

				xhr.send(opts.data || null);
			} catch (e) {
				if (opts.error) {
					opts.error.apply($this, [ e, xhr.status, xhr.response,
							options ]);
				}
				console.error("ajaxFileDownloader error with:", e);
			}
		}
	};

	$.ajaxFileDownloader = function(option) {
		var opt = {};
		// 新方式
		if (typeof option == "object") {
			opt = $.extend({}, $.ajaxFileDownloader.defaults, option);
		}
		// 使用default和option作为参数
		return new AjaxFileDownloader(opt);
	};

	$.ajaxFileDownloaderPost = function(option) {
		var opt = {};
		// 新方式
		if (typeof option == "object") {
			opt = $.extend({}, $.ajaxFileDownloader.defaults, option, {
				"type" : "POST",
				"contentType" : "application/json; charset=UTF-8"
			});
		}
		// 使用default和option作为参数
		return new AjaxFileDownloader(opt);
	};

	$.ajaxFileDownloader.defaults = {
		"type" : "GET", // 请求方式 默认:GET
		"url" : "",// 请求url
		"async" : true, // 异步执行
		"contentType" : "application/x-www-form-urlencoded; charset=UTF-8",
		"headers" : {}, // 自定义请求头
	};

})();


//////////////////
// WEBPACK FOOTER
// ./static/js/ajaxFileDownloader.js
// module id = RT7X
// module chunks = 11